const PROXY_TEMPLATE_URL =
  'https://api.lumi.new/v1/functions/p427216140118241280/proxy-template'

function blobParaImagem(blob: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(objectUrl)
      resolve(img)
    }
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('Não foi possível decodificar o template.'))
    }
    img.src = objectUrl
  })
}

function dataUrlParaImagem(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('Não foi possível carregar a imagem.'))
    img.src = url
  })
}

export async function carregarImagem(url: string): Promise<HTMLImageElement> {
  if (url.startsWith('data:')) {
    return dataUrlParaImagem(url)
  }

  const res = await fetch(PROXY_TEMPLATE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  })

  if (!res.ok) {
    throw new Error('Não foi possível carregar o template.')
  }

  const blob = await res.blob()
  if (!blob || blob.size === 0) {
    throw new Error('Não foi possível carregar o template.')
  }

  return blobParaImagem(blob)
}
